import React from "react";
import StyledContainer from "../../styles/StyledContainer";

const Container = ({ children }) => (
  <StyledContainer>{children}</StyledContainer>
);

export default Container;
